import { Bell } from 'lucide-react';
import { type ReactElement } from 'react';
import type { Getter, Row, Table } from '@tanstack/react-table';

import { AlarmActivationSeverity } from '@crossnokaye/typescript-sdk/models/components/alarmactivation';
import { cn, DataTableMeta, Gutter } from '@crossnokaye/ux-common';

import { Icon } from '@/ux-common/components/icon';

import { getAlarmIconConfig } from './helpers';

/**
 *
 * @param param0 Cell context.
 * @returns ReactElement.
 */
export const SeverityCell = <TData extends { status: 'Active' | 'Inactive' }>({
  getValue,
  row,
  table,
}: {
  getValue: Getter<AlarmActivationSeverity>;
  row: Row<TData>;
  table: Table<TData>;
}): ReactElement => {
  const severity = getValue() as AlarmActivationSeverity;
  const isMobile = (table.options.meta as DataTableMeta<TData>)?.isMobile;

  const { color, background, isPulsing } = getAlarmIconConfig(
    severity,
    row.original.status === 'Active'
  );

  return (
    <Gutter size="responsive">
      <div className={'flex flex-row items-center gap-1'}>
        <Icon data-testid="icon" className={cn('icon-sm', background, isPulsing && 'icon-pulse')}>
          <Bell className={cn('glyph glyph-sm', color)} aria-hidden="true" />
        </Icon>
        {!isMobile && (
          <span className={'text-sm truncate px-1'}>
            {severity.charAt(0).toUpperCase() + severity.slice(1)}
          </span>
        )}
      </div>
    </Gutter>
  );
};
